module.exports = __webpack_public_path__ + "img/text_only.777cfcd5.png";